const CONTROLLER = "/jobs";
const PATHS = {
	PUBLISH_JOB: "",
	GET_ALL_JOBS: "",
	GET_SAVED_JOBS: "/saved-jobs",
	GET_APPLIED_JOBS: "/appl/list",
	GET_JOB_APPLICANTS: "/:job_id/appl/list",
	GET_JOB_BY_ID: "/:job_id",
	MODIFY_JOB: "/:job_id",
	DELETE_JOB: "/:job_id",
	SEND_APPLICATION: "/:job_id/appl",
	DELETE_APPLICATION: "/:job_id/appl",
	SHARE_JOB: "/:job_id/share",
	SAVE_JOB: "/:job_id/save",
	UNSAVE_JOB: "/:job_id/save",
	CHECK_IF_JOB_IS_SAVED_BY_USER: "/:job_id/save",
};

export const JobApiRoutes = {
	CONTROLLER,
	PATHS,
	PUBLISH_JOB: `${CONTROLLER}${PATHS.PUBLISH_JOB}`,
	GET_ALL_JOBS: `${CONTROLLER}${PATHS.GET_ALL_JOBS}`,
	GET_SAVED_JOBS: `${CONTROLLER}${PATHS.GET_SAVED_JOBS}`,
	GET_APPLIED_JOBS: `${CONTROLLER}${PATHS.GET_APPLIED_JOBS}`,
	GET_JOB_APPLICANTS: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_JOB_APPLICANTS.replace(
			":job_id",
			String(job_id)
		)}`,
	GET_JOB_BY_ID: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.GET_JOB_BY_ID.replace(":job_id", String(job_id))}`,
	MODIFY_JOB: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.MODIFY_JOB.replace(":job_id", String(job_id))}`,
	DELETE_JOB: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.DELETE_JOB.replace(":job_id", String(job_id))}`,
	SEND_APPLICATION: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.SEND_APPLICATION.replace(":job_id", String(job_id))}`,
	DELETE_APPLICATION: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.DELETE_APPLICATION.replace(
			":job_id",
			String(job_id)
		)}`,
	SHARE_JOB: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.SHARE_JOB.replace(":job_id", String(job_id))}`,
	SAVE_JOB: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.SAVE_JOB.replace(":job_id", String(job_id))}`,
	UNSAVE_JOB: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.UNSAVE_JOB.replace(":job_id", String(job_id))}`,
	CHECK_IF_JOB_IS_SAVED_BY_USER: (job_id: string | undefined) =>
		`${CONTROLLER}${PATHS.CHECK_IF_JOB_IS_SAVED_BY_USER.replace(
			":job_id",
			String(job_id)
		)}`,
};
